module.exports = __webpack_public_path__ + "img/myCopysend.c09cb7a3.svg";